// extracted by mini-css-extract-plugin
module.exports = {"name-card-image":"NameCard_name-card-image__gmMr3","name-card-name":"NameCard_name-card-name__2tb62"};